document.addEventListener("DOMContentLoaded", function () {
    const COOKIE_NAME = "cstm-sale-timer";

    // Get timestamp for next local midnight
    function getLocalMidnightTimestamp() {
      const now = new Date();
      const midnight = new Date();

      midnight.setHours(24, 0, 0, 0); // Midnight = 00:00:00 of next day

      return midnight.getTime();
    }

    function getRemainingTime(targetTimestamp) {
      const now = Date.now();
      const diff = targetTimestamp - now;

      return {
        total: diff,
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60)
      };
    }

    function setCookie(name, value, expires) {
      document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`;
    }

    function getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (const cookie of cookies) {
        const [key, val] = cookie.split("=");
        if (key === name) return val;
      }
      return null;
    }

    function startTimer() {
      const el = document.getElementById("cstm-sale-timer");
      if (!el) return;

      let targetTimestamp = getLocalMidnightTimestamp();
      const now = Date.now();

      const cookie = getCookie(COOKIE_NAME);
      if (cookie && !isNaN(cookie)) {
        const parsed = parseInt(cookie, 10);
        if (parsed > now && parsed <= targetTimestamp) {
          targetTimestamp = parsed;
        }
      }

      // Set cookie for later reference
      setCookie(COOKIE_NAME, targetTimestamp, new Date(targetTimestamp));

      function update() {
        const time = getRemainingTime(targetTimestamp);
        if (time.total <= 0) {
          el.textContent = "00:00:00";
          return;
        }

        const h = String(time.hours).padStart(2, "0");
        const m = String(time.minutes).padStart(2, "0");
        const s = String(time.seconds).padStart(2, "0");

        el.textContent = `${h}:${m}:${s}`;
      }

      update();
      setInterval(update, 1000);
    }

    startTimer();
  });